import React from 'react';
import style from './stripePlansPage.module.scss';

import StripePlans from '../../Components/SignUpWorkflow/StripePlans/StripePlans'

const StripePlansPage = () => {
    
    return (
      <div className={style.pageWrapper}>
        <StripePlans versionPage='withoutInput'/>
      </div>
    );
  };
  
  export default StripePlansPage;